import { useMemo } from 'react';
import { useAllClients } from './useAllClients';
import { useEmpStatus } from './useOnlineEmployee';
import { useSelector } from 'react-redux';
import { filterData } from 'common/commonRedux/feature/filteringSlice';

export const useClientsWithActiveFirst = () => {
  const { clients, refetchClients } = useAllClients();
  const { uniqueEmpsOnline } = useEmpStatus();
  const getFilterData = useSelector(filterData);
  const { searchValue, clientIdString, clientName } = getFilterData || {};
// console.log('Filter Data:', uniqueEmpsOnline);
 const sortedClients = useMemo(() => {
  const onlineIds = new Set(
    uniqueEmpsOnline.map((id: any) => String(id))
  );
  

  return clients
    .filter((client) => {
      const matchesSearch = searchValue
        ? client.employeeName?.toLowerCase().includes(searchValue.toLowerCase()) ||
          client.employeeEmail?.toLowerCase().includes(searchValue.toLowerCase())
        : true;

      const matchesClientId = clientIdString
        ? String(client.employeeId) === String(clientIdString)
        : true;

      return matchesSearch && matchesClientId;
    })
    .sort((a, b) => {
      const aOnline = onlineIds.has(String(a.employeeId)) ? 0 : 1;
      const bOnline = onlineIds.has(String(b.employeeId)) ? 0 : 1;
      return aOnline - bOnline;
    });

}, [clients, uniqueEmpsOnline, searchValue, clientIdString]);
  return { clients: sortedClients, refetchClients };
};